import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import './loading-overlay-style.css'

class LoadingSkeleton extends React.Component {
    // constructor(props) {
    //     super(props)
    // }

    render() {
        return (
            <div className='loading'>
                <div className="spinner-skeleton">
                    <div>
                        <SkeletonTheme highlightColor="#007bff">
                            <h5><Skeleton /></h5>
                            {/* <p><Skeleton count={3} /></p> */}
                        </SkeletonTheme>
                    </div>
                </div>
            </div>

        );
    }
}

export default LoadingSkeleton;